// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DebugPanel__dialog--2K-_a","ace_editor":"DebugPanel__ace_editor--30i3C"};